import 'aos/dist/aos.css';
import AOS from 'aos';
import { useState, useEffect } from "react";
import PaymentApiService from '../../ApiServices/PaymentApiServices/PaymentApiService';
import { Banknote, CreditCard, Landmark, MapPin, User, Shield, Home, CheckCircle, Calendar } from "lucide-react";
import DataTable from 'react-data-table-component';
import { DataStyles } from '../Common/DataTableStyles'; // Adjust path based on your structure

const PaymentDetailsTable = () => {
    const [data, setData] = useState([]);

    useEffect(() => {
        AOS.init({ duration: 1000, once: true });
        fetchData();
    }, []);

    const fetchData = async () => {
        try {
            const paymentData = await PaymentApiService.Get();
            setData(paymentData.data || []);
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    const columns = [
        {
            name: <div className="flex items-center gap-2"><User size={16} /> Publisher</div>,
            selector: row => `${row.user?.firstName} ${row.user?.lastName}`,
            sortable: true,
            wrap: true
        },
        {
            name: <div className="flex items-center gap-2"><CreditCard size={16} /> Bank Account</div>,
            selector: row => row.bankAccountNumber,
            sortable: true
        },
        {
            name: <div className="flex items-center gap-2"><Banknote size={16} /> Bank Name</div>,
            selector: row => row.bankName,
            sortable: true
        },
        {
            name: <div className="flex items-center gap-2"><Landmark size={16} /> Branch</div>,
            selector: row => row.bankBranch,
            sortable: true
        },
        {
            name: <div className="flex items-center gap-2"><User size={16} /> Owner</div>,
            selector: row => row.owner,
            sortable: true
        },
        {
            name: <div className="flex items-center gap-2"><Shield size={16} /> Swift Code</div>,
            selector: row => row.swiftCode,
            sortable: true
        },
        {
            name: <div className="flex items-center gap-2"><Home size={16} /> Address</div>,
            selector: row => row.address,
            sortable: true,
            wrap: true
        },
        {
            name: <div className="flex items-center gap-2"><CheckCircle size={16} /> Status</div>,
            selector: row => row.isActive ? 'Active' : 'Inactive',
            cell: row => (
                <span className={`px-2 py-1 text-xs font-semibold rounded-full ${row.isActive ? "bg-green-200 text-green-700" : "bg-red-200 text-red-700"}`}>
                    {row.isActive ? "Active" : "Inactive"}
                </span>
            ),
            sortable: true
        },
        {
            name: <div className="flex items-center gap-2"><Calendar size={16} /> Created On</div>,
            selector: row => new Date(row.createdOn).toLocaleDateString(),
            sortable: true
        }
    ];

    return (
        <div className="p-6 bg-gray-100 min-h-screen flex-grow">
            <div className="max-w-7xl mx-auto space-y-6">
                <div className="bg-white shadow-lg rounded-lg p-6">
                    <h3 className="text-lg font-semibold text-gray-900 mb-4">Bank Account Details</h3>
                    <DataTable
                        columns={columns}
                        data={data}
                        pagination
                        highlightOnHover
                        striped
                        responsive
                        persistTableHead
                        customStyles={DataStyles}
                    />
                </div>
            </div>
        </div>
    );
};

export default PaymentDetailsTable;
